import {
  GetChatMessageAttachmentsData,
  ChatMessagesData,
} from 'core_main/api/messages/types';
import {
  IncludedUser,
  Included,
  IncludedTemplate,
  IncludedArticle,
} from 'core_main/pubnub/types';
import { addUserToStore } from 'core_main/store';
import { MessageTemplate } from 'core_main/api/assistant/types';
import {
  MessageCallbackResponse,
  MessageAttachmentCallbackResponse,
} from './types';
import { createArticleCallbackResponse } from '../get_articles/helpers';

export const createAttachmentCallbackResponse = (
  attachment: GetChatMessageAttachmentsData,
): MessageAttachmentCallbackResponse => {
  const { related } = attachment?.links;
  const { id } = attachment;
  const { contentLength, contentType, name } = attachment.attributes;

  return { url: related, attachmentId: id, contentLength, contentType, name };
};
export const createMessageCallbackResponse = (
  messageData: ChatMessagesData,
  attachments?: GetChatMessageAttachmentsData[],
  includedData?: Included[],
): MessageCallbackResponse => {
  const includedUser = includedData?.find(
    (included) => included.type === 'user',
  ) as IncludedUser;
  const userAttributes = includedUser?.attributes;

  if (userAttributes) {
    const userId = includedUser?.id;
    addUserToStore(userId, userAttributes);
  }

  const includedTemplate = includedData?.find(
    (included) => included.type === 'template',
  ) as IncludedTemplate;

  const includedArticles = (includedData?.filter(
    (included) => included.type === 'article',
  ) as IncludedArticle[])?.map(createArticleCallbackResponse);

  const { id: messageId, attributes, relationships } = messageData;

  let attachmentCallbackResponses;

  if (attachments?.length) {
    attachmentCallbackResponses = attachments.map((attachment) =>
      createAttachmentCallbackResponse(attachment),
    );
  }

  const { body, createdAt, direction, auto } = attributes;
  const conversationId = relationships.session.data.id;
  const sentByType = relationships.sentBy?.data?.type;
  const sentById = relationships.sentBy?.data?.id;
  const displayName = userAttributes?.displayName;
  const avatarUrl = userAttributes?.avatarUrl;

  const template: MessageTemplate = includedTemplate && {
    ...includedTemplate?.attributes,
    id: includedTemplate?.id,
  };

  return {
    messageId,
    body,
    createdAt,
    direction,
    conversationId,
    attachments: attachmentCallbackResponses,
    meta: {
      template,
      articles: includedArticles,
    },
    sentBy: {
      type: auto ? 'user' : sentByType,
      id: sentById,
      displayName,
      avatarUrl,
    },
  };
};
